import Vuex from 'vuex'
import Vue from 'vue'
import Api from '@/util/api'
import Apis from '@/util/apis'
import SlimApi from '@/util/slimapi'
import Constants from '@/util/constants'
import terminal from '@/services/terminal'
import util from '@/util/util'
import { getLanguage } from '@/util/language'
import Data from '@/util/data'
import { UserPNL } from '../util/types'
import $router from '@/router/index'

Vue.use(Vuex)

function shortNumber (num) {
  if (num > 1000000) {
    let a = num / 1000000
    a = a.toFixed(1) + 'M'
    return a
  }
  if (num > 1000) {
    let b = num / 1000
    b = b.toFixed(1) + 'K'
    return b
  }
  return parseFloat(num).toFixed(1)
}

function localTime (utctime) {
  return new Date(utctime).toLocaleString('ru-RU').replace(',', '')
}

function elapsed (start, end) {
  const startDate = new Date(start)
  const endDate = new Date(end)
  const seconds = (endDate.getTime() - startDate.getTime()) / 1000
  // return endDate
  // var srcdate = new Date(seconds * 1000).toISOString().substr(11, 8)
  return secondsToHms(seconds)
}

function secondsToHms (secs) {
  secs = Number(secs)
  const d = Math.floor(secs / 86400)
  const h = Math.floor(secs % 86400 / 3600)
  const m = Math.floor(secs % 3600 / 60)
  const s = Math.floor(secs % 3600 % 60)

  const hDisplay = h > 0 ? h + Data.vm.$text.tr('ч') + ' ' : ''
  const mDisplay = m > 0 ? m + Data.vm.$text.tr('м') : ''
  // var sDisplay = s > 0 ? s + 'с' : ''
  let res = hDisplay + mDisplay
  if (d === 0 && h === 0) {
    res = res + ' ' + s + Data.vm.$text.tr('с')
  }
  if (d > 0) {
    res = d + Data.vm.$text.tr('д') + ' ' + res
  }
  return res // + sDisplay
}

// var tok1 = window.location.hash.substr(9)
// if (tok1.length > 80) {
//   localStorage.setItem('token', tok1)
// }

function tradeExchangeKey (demo) {
  return demo ? 'capico_app_tradeExchange_demo' : 'capico_app_tradeExchange_real'
}

function saveTradeExchange (exchange, demo) {
  localStorage.setItem(tradeExchangeKey(demo), JSON.stringify(exchange))
}

function loadTradeExchange (demo) {
  try {
    const val = localStorage.getItem(tradeExchangeKey(demo))
    if (val) return JSON.parse(val)
  } catch {
    // ignore
  }
  try {
    const val = localStorage.getItem('capico_app_tradeExchange')
    if (val) return JSON.parse(val)
  } catch {
    // ignore
  }
  return null
}

export { saveTradeExchange, loadTradeExchange }

let tradeExch = loadTradeExchange(getLocalStorageBoolean('capico_app_demoState')) || {}

let selSymb = {}
try {
  selSymb = JSON.parse(localStorage.getItem('capico_app_selSymbols'))
} catch (e) {
  // console.log(e)
}

let symbol = 'BTC_USDT'
if (tradeExch && selSymb && selSymb[tradeExch.Id]) {
  symbol = selSymb[tradeExch.Id]
} else if (tradeExch) {
  switch (tradeExch.ExchId) {
    case 'EXM':
    case 'BIT':
      symbol = 'BTC_USD'
  }
} else {
  tradeExch = {}
  // selSymb = {}
}
let botSymbol = 'BTC_USDT'
// var savedBotSymbol = localStorage.getItem('capico_app_botSymbol')
// if (savedBotSymbol) {
//   botSymbol = savedBotSymbol
// }
const chartInfo = {
  ExchId: tradeExch.ExchId,
  TradeSymbol: symbol
}
if (!chartInfo.ExchId) {
  chartInfo.ExchId = 'BIN'
}

let exchSymbol = {}
try {
  exchSymbol = JSON.parse(localStorage.getItem('capico_app_botExchSymbol'))
} catch (e) {}

if (tradeExch && exchSymbol && exchSymbol[tradeExch.Id]) {
  botSymbol = exchSymbol[tradeExch.Id]
} else if (tradeExch) {
  switch (tradeExch.ExchId) {
    case 'EXM':
    case 'BIT':
    case 'FTX':
      botSymbol = 'BTC_USD'
  }
}
if (!exchSymbol) {
  exchSymbol = {}
}

let fastbotAsset = localStorage.getItem('capico_app_fastbotAsset')
if (!fastbotAsset) {
  fastbotAsset = 'BTC'
}

let leverage = 10
try {
  const parsedLeverageValue = JSON.parse(localStorage.getItem('capico_app_leverage'))

  if (parsedLeverageValue !== null) {
    leverage = parsedLeverageValue
  }
} catch (e) {}

let language = localStorage.getItem('capico_app_lang')
if (!language) {
  language = getLanguage()
}
let tradetype = localStorage.getItem('capico_app_trade_type')
if (!tradetype) {
  tradetype = 'limit'
}

let tradesFilter = null
try {
  tradesFilter = JSON.parse(localStorage.getItem('trades_filter_dates'))
} catch (e) {}

const d = new Date()
d.setHours(0, 0, 0, 0)
const dates = [new Date(d - 2505600000), d]

function getLocalStorageBoolean (key = '', defaultValue = true) {
  const item = localStorage.getItem(key)

  switch (item) {
    case null:
      return defaultValue
    case 'true':
      return true
    default:
      return false
  }
}

export default new Vuex.Store({
  state: {
    sltpModal: false,
    sltpIndex: 0,
    sltpTrade: true, // true => trade mode / false => smart sell
    sys: {
      rates: { eth: '', btc: '' },
      token: localStorage.getItem('token'),
      // devtkn: localStorage.getItem('devtkn'),
      tradeExchange: tradeExch, // {Id: 'vwum', ExchId: 'BIN'},
      chartInfo,
      tradeExchangeIndex: -1,
      selSymbols: selSymb,
      lastPrice: '',
      lastTrade: {},
      freeBalance: '',
      freeBalance2: '',
      demo: getLocalStorageBoolean('capico_app_demoState'),
      email: '',
      exchanges: [],
      allexchanges: [],
      exchangesLoaded: false,
      exchValue: {},
      usdbtc: 'USD',
      lang: language,
      hideBalances: localStorage.getItem('capico_app_hide_balances') === 'true',
      isConstructorModeAllowed: getLocalStorageBoolean('isConstructorModeAllowed'),
      isNoConfirmationMode: localStorage.getItem('isNoConfirmationMode') === 'true',
      unwatchLastPrice: () => {},
      theme: localStorage.getItem('theme') || 'default',
      modalObservers: [],
      isDashboardResponsive: false,
      breakpoint: '',
      isMenuCollapsed: getLocalStorageBoolean('isMenuCollapsed', false),
      isHeaderCollapsed: getLocalStorageBoolean('isHeaderCollapsed', false)
    },
    bots: {
      // edit: false,
      symbol: botSymbol,
      exchSymbol,
      freeBal: '',
      lastPrice: '',
      editBot: {},
      botsUpdated: 0,
      botName: '',
      autoLaunch: false,
      amount: '',
      buyPrice: '',
      sellPrice: '',
      slPrice: '',
      stopLoss: false,
      slTimeout: 60,
      slTimeoutEnabled: false,
      triggerPrice: '',
      trigger: false,
      botsList: [],
      activeBotsList: [],
      editMode: false,
      setSymbolNeeded: 0,
      accumulateType: 'Q',
      showArrows: getLocalStorageBoolean('capico_app_botTV_showArrows'),
      showOrders: getLocalStorageBoolean('capico_app_botTV_showOrders')
    },
    grids: {
      list: [],
      leverage: 5,
      marginType: 'cross',
      amount: '10',
      maxPrice: '89000',
      minPrice: '82000',
      gridsNum: 10,
      symbol: botSymbol,
      exchSymbol,
      freeBal: '0',
      lastPrice: '',
      editBot: {},
      botsUpdated: 0,
      gridsUpdated: 0,
      editMode: false,
      editGrid: {},
      profitCollection: 'USDT',
      slPrice: '',
      stopLoss: false,
      simTrades: [],
      showArrows: getLocalStorageBoolean('capico_app_gridTV_showArrows'),
      showOrders: getLocalStorageBoolean('capico_app_gridTV_showOrders')
    },
    assetPanicSellModal: {
      show: false
    },
    confirmModal: { // confirm Trade Modal
      show: false
    },
    confirmActionModal: { // generic confirm Modal
      show: false,
      text: '',
      btnName: '',
      tradeId: '',
      actionId: '',
      actionFunc: (tradeId, actionId) => {}
    },
    rebuyModal: {
      show: false,
      rebuyTrade: {}
    },
    openOrdersModal: {
      show: false,
      openOrders: []
    },
    editCommentModal: {
      show: false,
      tid: '',
      comment: ''
    },
    show: {
      exchangeModal: false,
      exchangeModalIndex: -1
    },
    data: {
      allSymbols: [],
      symbols: [],
      symbolsTV: [],
      symbolsfilter: {}
    },
    calls: {
      addnewtp: 1
    },
    trade: {
      type: tradetype,
      symbol,
      pair: symbol.split('_'),
      side: 'B',
      price: '0',
      qty: '0',
      amount: '0',
      slprice: '',
      tpprice: '',
      sltrail: '',
      tptrail: '',
      tpsteps: [],
      comment: '',
      direction: '',
      leverage,
      marginType: '',
      showTV: getLocalStorageBoolean('capico_app_showTV'),
      tvEnabled: false,
      tvLoading: false,
      dataLoading: true,
      editTradeId: null, // edit mode on graf for trade
      editTrade: null, // edit mode on graf for trade
      setTradeSymbolNeeded: 0,
      // pairFilledOrders: [],
      symbolTPs: [],
      symbolOrders: [],
      symbolSOs: [],
      symbolConds: [],
      symbolSLs: [],
      showArrors: getLocalStorageBoolean('capico_app_tv_showArrows'),
      showOrders: getLocalStorageBoolean('capico_app_tv_showOrders'),
      lastTrade: 0,
      tabBarSelectedItem: 'Trades',
      slAdded: false,
      slcEnabled: false,
      editQtyFocused: false
    },
    assets: {
      data: [],
      allexchs: false,
      allexchsdata: [],
      total: {}
    },
    trades: {
      choosenTradeIndex: 0,
      tradesFiltered: [],
      loading: false,
      limit: localStorage.getItem('trades_filter_limit') || '50',
      dates: tradesFilter || [],
      data: {
        Trades: [],
        Total: 0,
        Green: 0,
        Red: 0
      },
      filt: {
        stat: localStorage.getItem('trades_filter_stat') || 'ALL',
        side: localStorage.getItem('trades_filter_side') || 'ALL',
        type: 'act',
        allpairs: true,
        allexchs: true
      },
      profitInQuote: localStorage.getItem('capico_profitinquote') === 'true'
    },
    pay: {
      selectedPeriod: '1'
    },
    risk: {
      risk: '',
      riskUpdateInterval: null
    },
    fastbot: {
      asset: fastbotAsset,
      list: [],
      selected: undefined,
      type: 'ACT',
      excOrders: [],
      excOrdersArrows: [],
      freeBal: '',
      exchanges: [],
      exchTokenId: '',
      exchTokenLoaded: false,
      symbols: [],
      symbolsfilter: {},
      showAddExchangeModal: false,
      page: 0,
      lastPage: false,
      markPrice: '',
      showArrows: localStorage.getItem('fastbot_tv_showArrows') === 'true'
    },
    stats: {
      PNLByDay: {},
      TotalPNLByDay: {},
      Trades: { Pos: 0, Neg: 0, Orders: 0, Volume: 0, PNL: 0 },
      Bots: { Pos: 0, Neg: 0, Orders: 0, Volume: 0, PNL: 0 },
      Boosters: { Pos: 0, Neg: 0, Orders: 0, Volume: 0, PNL: 0 },
      Total: { Orders: 0, Volume: 0, PNL: 0 }
    },
    statsdata: {
      Dates: dates,
      TradeStat: true,
      BotStat: true,
      BoosterStat: true,
      LoadingTrades: false,
      LoadingBots: false,
      LoadingBoosters: false
    },
    hooks: {
      hookList: [],
      currentHookIndex: 0,
      isEditingHook: false,
      cashedCurrentHook: {},
      showMobileHookList: false
    }
    // assetsTotal: 0,
    // assetsTotalBTC: 0,
  },
  mutations: {
    setDemoState: function (state, value) {
      state.sys.demo = value
      localStorage.setItem('capico_app_demoState', value)
    },
    setExchValue (state, value) {
      state.sys.exchValue = value
    },
    setModalObservers (state, listener) {
      state.sys.modalObservers.length = 0
      const modals = document.getElementsByClassName('ivu-modal-wrap')
      window.addEventListener('keydown', listener)

      const toggleListener = (mutation) => {
        if (mutation.target.classList.contains('ivu-modal-hidden')) {
          window.addEventListener('keydown', listener)
        } else {
          window.removeEventListener('keydown', listener)
        }
      }

      const onMutationCallback = (mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            toggleListener(mutation)
          }
        }
      }

      modals.forEach((modal) => {
        const observer = new MutationObserver(onMutationCallback)
        observer.observe(modal, { attributes: true })
        state.sys.modalObservers.push(observer)
      })
    },
    destroyModalObservers (state, listener) {
      window && window.removeEventListener('keydown', listener)
      state.sys.modalObservers.forEach((observer) => {
        observer.disconnect()
      })

      state.sys.modalObservers.length = 0
    }
  },
  getters: {
    isFutures (state, getters) {
      return getters.isBIF || getters.isBYF || getters.isFTXFutures || getters.isOKXFutures || getters.isBitgetFutures
    },
    isBIF (state, getters) {
      return getters.exchId === 'BIF'
    },
    isBYF (state, getters) {
      return getters.exchId === 'BYF'
    },
    isFTXFutures (state, getters) {
      return getters.exchId === 'FTX' && getters.tradeSymbol.includes('-')
    },
    isOKXFutures (state, getters) {
      return getters.exchId === 'OKX' && getters.tradeSymbol.includes('-')
    },
    isBitgetFutures (state, getters) {
      return getters.exchId === 'GEF'
    },
    exchId (state) {
      return state.sys.tradeExchange.ExchId
    },
    tradeSymbol (state) {
      return state.trade.symbol
    },
    isThemeLight (state) {
      return state.sys.theme === 'light'
    },
    currentHook (state) {
      return (
        state.hooks.hookList.length &&
        state.hooks.hookList[state.hooks.currentHookIndex]
      )
    },
    demoState: function (state) {
      return state.sys.demo
    }
  },
  actions: {
    async updateSymbols (store, payload) {
      if (store.state.sys.tradeExchange.Id === undefined) {
        return
      }
      await Apis[util.exchId2sputnik(store.state.sys.tradeExchange.ExchId)]
        .get('exch/symbols?token=' + store.state.sys.token + '&etid=' + store.state.sys.tradeExchange.Id)
        .then(response => {
          store.state.data.symbols = response.data.Symbols
          store.state.data.symbolsfilter = {}
          // var newSymbolsTV = []
          if (response.data.Symbols) {
            response.data.Symbols.forEach((item, index) => {
              store.state.data.symbolsfilter[item.baseAsset + '_' + item.quoteAsset] = item
              // item.VolShort = shortNumber(item.Volume24h)
              // var exch = Constants.exchangeTVIds[store.state.sys.tradeExchange.ExchId]
              // newSymbolsTV.push(
              //   {
              //     'symbol': item.baseAsset + '/' + item.quoteAsset,
              //     'ticker': exch + ':' + item.baseAsset + '/' + item.quoteAsset, // e.g. BTCE:BTCUSD
              //     'description': '',
              //     'exchange': exch,
              //     'full_name': exch + ':' + item.baseAsset + item.quoteAsset,
              //     'type': 'bitcoin'
              //   }
              // )
            })
          }

          if (payload && payload.z) {
            payload.z()
          }
          // console.log('updateSymbols done2')

          // store.state.data.symbolsTV = newSymbolsTV
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    async updateExchangesAsync (store) {
      // console.log('updateExchangesAsync')
      try {
        const params = {
          params: {
            token: store.state.sys.token,
            demo: store.state.sys.demo ? '1' : '0'
          }
        }
        const response = await Api.get('user/info', params)

        // await new Promise(resolve => setTimeout(resolve, 3000))

        if (response.status === Constants.http.OK) {
          // console.log('response.data: ', response.data)
          store.state.sys.email = response.data.Email
          localStorage.setItem('email', store.state.sys.email)

          if (store.state.sys.lang !== response.data.Lang) {
            store.state.sys.lang = response.data.Lang
            localStorage.setItem('capico_app_lang', store.state.sys.lang)
            Data.vm.$router.go(0)
          }

          try {
            const respsg = await Apis.sg.get('user/info', params)
            if (respsg.status === Constants.http.OK) {
              respsg.data.exchanges.forEach(exch => {
                exch.sptnk = 'sg'
                response.data.exchanges.push(exch)
              })
            }
            response.data.exchanges.sort((a, b) => (a.Name.toLowerCase() < b.Name.toLowerCase()) ? -1 : ((b.Name.toLowerCase() > a.Name.toLowerCase()) ? 1 : 0))
          } catch (err) {
            console.log(err)
          }

          try {
            const respsg = await Apis.get.get('user/info', params)
            if (respsg.status === Constants.http.OK) {
              // console.log('sgexch: ', JSON.stringify(respsg.data.exchanges))
              respsg.data.exchanges.forEach(exch => {
                exch.sptnk = 'get'
                response.data.exchanges.push(exch)
              })
              response.data.exchanges.sort((a, b) => (a.Name.toLowerCase() < b.Name.toLowerCase()) ? -1 : ((b.Name.toLowerCase() > a.Name.toLowerCase()) ? 1 : 0))
            }
          } catch (err) {
            console.log(err)
          }

          store.state.sys.allexchanges = response.data.exchanges
          store.state.sys.exchangesLoaded = true
          store.state.sys.exchanges = []
          response.data.exchanges.forEach(exch => {
            if ((!exch.Demo && exch.Demo !== false) || exch.Demo === store.state.sys.demo) {
              store.state.sys.exchanges.push(exch)
            }
          })
          if (store.state.sys.exchanges.length === 0) {
            store.state.sys.tradeExchange = {}
          } else {
            const savedId = (loadTradeExchange(store.state.sys.demo) || {}).Id
            const selectedId = savedId || store.state.sys.tradeExchange.Id
            const trExch = store.state.sys.exchanges.find(e => e.Id === selectedId) || store.state.sys.exchanges[0] || {}
            trExch.TradeSymbol = 'BTC_USDT'
            store.state.sys.tradeExchange = trExch
            saveTradeExchange(store.state.sys.tradeExchange, store.state.sys.demo)
            terminal.updateExchValue()
          }
          // console.log('updateExchanges finished')
        }
      } catch (err) {
        console.log(err)
      }
    },
    updateExchanges (store) {
      const params = {
        params: {
          token: store.state.sys.token,
          demo: store.state.sys.demo ? '1' : '0'
        }
      }
      return Api.get('user/info', params).then(async response => {
        if (response.status === Constants.http.OK) {
          store.state.sys.email = response.data.Email

          try {
            const respsg = await Apis.sg.get('user/info', params)
            if (respsg.status === Constants.http.OK) {
              // console.log('sgexch: ', JSON.stringify(respsg.data.exchanges))
              respsg.data.exchanges.forEach(exch => {
                exch.sptnk = 'sg'
                response.data.exchanges.push(exch)
              })
            }
            response.data.exchanges.sort((a, b) => (a.Name.toLowerCase() < b.Name.toLowerCase()) ? -1 : ((b.Name.toLowerCase() > a.Name.toLowerCase()) ? 1 : 0))
          } catch (err) {
            console.log(err)
          }

          try {
            const respsg = await Apis.get.get('user/info', params)
            if (respsg.status === Constants.http.OK) {
              // console.log('sgexch: ', JSON.stringify(respsg.data.exchanges))
              respsg.data.exchanges.forEach(exch => {
                exch.sptnk = 'get'
                response.data.exchanges.push(exch)
              })
              response.data.exchanges.sort((a, b) => (a.Name.toLowerCase() < b.Name.toLowerCase()) ? -1 : ((b.Name.toLowerCase() > a.Name.toLowerCase()) ? 1 : 0))
            }
          } catch (err) {
            console.log(err)
          }

          store.state.sys.allexchanges = response.data.exchanges
          store.state.sys.exchangesLoaded = true
          store.state.sys.exchanges = []
          response.data.exchanges.forEach(exch => {
            if ((!exch.Demo && exch.Demo !== false) || exch.Demo === store.state.sys.demo) {
              store.state.sys.exchanges.push(exch)
            }
          })
          // store.state.sys.exchanges = response.data.exchanges
          if (store.state.sys.exchanges.length === 0) {
            store.state.sys.tradeExchange = {}
          } else {
            const savedId = (loadTradeExchange(store.state.sys.demo) || {}).Id
            const selectedId = savedId || store.state.sys.tradeExchange.Id
            store.state.sys.tradeExchange = store.state.sys.exchanges.find(e => e.Id === selectedId) || store.state.sys.exchanges[0] || {}
            saveTradeExchange(store.state.sys.tradeExchange, store.state.sys.demo)
            terminal.updateExchValue()
          }
          // console.log('updateExchanges finished')
        }
      }).catch(error => {
        console.log(error)
      })
    },
    async updateAssetBalance (store, ignorePrice) {
      // console.log('tradeExchange.Id', store.state.sys.tradeExchange.Id)
      if (!store.state.sys.tradeExchange.Id) {
        return
      }
      await Apis[util.exchId2sputnik(store.state.sys.tradeExchange.ExchId)]
        .get(
          'asset/balance?token=' + store.state.sys.token + '&etid=' + store.state.sys.tradeExchange.Id + '&symbol=' +
          store.state.trade.symbol
        )
        .then(response => {
          // console.log('response', JSON.stringify(response))
          if (!ignorePrice) {
            store.state.trade.price = response.data.LastPrice
          }
          store.state.sys.lastPrice = response.data.LastPrice
          store.state.sys.freeBalance = response.data.QAssetFree
          store.state.sys.freeBalance2 = response.data.BAssetFree
          // this.minPrice = response.data.PriceMin
          // this.minQty = response.data.QtyMin
          // this.minAmount = response.data.AmountMin
          // this.priceDec = response.data.PriceDec
          // this.qtyDec = response.data.QtyDec

          // this.checkErrors()

          // this.$store.state.lastPrice = response.data.LastPrice

          // console.log(store.state.trade.price);
          // console.log(store.state.sys.freeBalance);
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    updateAssets (store) {
      // console.log('updateAssets started. trade exch: ', store.state.sys.tradeExchange)
      if ($router.currentRoute.name !== 'terminal' && $router.currentRoute.name !== 'portfolio') {
        return
      }
      if (store.state.sys.tradeExchange.Id === undefined) {
        store.state.assets = {
          data: [],
          allexchs: false,
          allexchsdata: [],
          total: {}
        }
        return
      }
      // todo speed up json parsing
      // console.time('updateAssets')
      // console.log('token: ', store.state.sys.token)
      // console.log('etid: ', store.state.sys.tradeExchange.Id)

      const uri = 'asset/listlite?token=' + store.state.sys.token + '&etid=' + store.state.sys.tradeExchange.Id
      // console.log('uri: ', uri)

      // console.log(this.$route)
      // const isProtfolioRoute = Data.vm.$router.currentRoute.name === 'portfolio'

      // if (store.state.assets.allexchs && isProtfolioRoute) {
      //   uri = 'asset/listlite?token=' + store.state.sys.token + '&etid=ALL'
      // }

      Apis[util.exchId2sputnik(store.state.sys.tradeExchange.ExchId)]
        .get(uri)
        .then(response => {
          // context.commit('UPDATE_ASSETS', response.data)
          // if (store.state.assets.allexchs && isProtfolioRoute) {
          //   store.state.assets.allexchsdata = response.data.Assets
          //   store.state.assets.total = response.data.Total
          // } else {
          store.state.assets.data = response.data.Assets
          // }
          // console.log(context.state.assets.data)
          // console.timeEnd('updateAssets')
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    cleanSltp (store) {
      store.state.trade.slprice = ''
      store.state.trade.tpprice = ''
      store.state.trade.sltrail = ''
      store.state.trade.tptrail = ''
      store.state.trade.tpsteps = []
    },
    updateTrades (store) {
      // console.log('route:', $router.currentRoute.name)
      if ($router.currentRoute.name !== 'terminal') {
        return
      }
      if (store.state.sys.tradeExchange.Id === undefined || store.state.sys.exchanges.length === 0) {
        store.state.trades.data.Trades = []
        store.state.trades.data.Total = 0
        store.state.trades.data.Green = 0
        store.state.trades.data.Red = 0
        store.state.trades.loading = false
        return
      }
      // console.time('receive trades');
      // store.state.trades.loading = true
      // var a = performance.now()
      // alert('do something...');

      let uri = 'trade/list?&token=' + store.state.sys.token + '&etid=' + store.state.sys.tradeExchange.Id +
        '&status=' + store.state.trades.filt.type + (store.state.trades.filt.allpairs ? '' : '&symbol=' + store.state.trade.symbol) +
        '&limit=' + store.state.trades.limit + '&trade_status=' + store.state.trades.filt.stat + '&side=' + store.state.trades.filt.side

      // console.log(store.state.trades.dates)
      if (store.state.trades.dates[0]) {
        uri += '&dates=' + store.state.trades.dates[0].getTime() / 1000 + ',' + ((store.state.trades.dates[1].getTime() / 1000) + 24 * 3600)
      }

      Apis[util.exchId2sputnik(store.state.sys.tradeExchange.ExchId)]
        .get(uri)
        .then(response => {
          if (response.data) {
            // console.log(JSON.stringify(response.data))

            if (response.data.err === 'etid not exists') {
              Data.vm.$Message.warning({
                content: Data.vm.$text.tr('Биржа перенесена. Страница обновится через 5с'),
                duration: 5
              })
              const newid = 'y' + store.state.sys.tradeExchange.Id
              store.state.sys.tradeExchange.Id = newid
              saveTradeExchange(store.state.sys.tradeExchange, store.state.sys.demo)
              // console.log('newid:', newid)
              setTimeout(() => {
                store.state.sys.tradeExchange.Id = newid
                // store.state.sys.tradeExchange.sptnk = 'sg'
                saveTradeExchange(store.state.sys.tradeExchange, store.state.sys.demo)
                window.location.reload()
              }, 5000)
              return
            }

            // var b = performance.now()
            // console.log('get trades: ' + (b - a) + ' ms.')
            response.data.Trades.forEach((part, i, theArray) => {
              // console.log('list trade: ', part)
              if (theArray[i].Closed) {
                theArray[i].Duration = elapsed(theArray[i].Created, theArray[i].Closed)
              }
              theArray[i].CreatedDate = new Date(theArray[i].Created)
              theArray[i].Created = localTime(theArray[i].Created)
              theArray[i].ClosedDate = new Date(theArray[i].Closed)
              theArray[i].Closed = localTime(theArray[i].Closed)

              if (theArray[i].Sl && theArray[i].Sl.length > 0) {
                if (!theArray[i].Sltp) {
                  theArray[i].Sltp = {}
                }
                // theArray[i].Sltp.SlTimeout = theArray[i].Sl[0].SlTimeout
                theArray[i].Sltp.SlPrice = theArray[i].Sl[0].Price
                theArray[i].Sltp.SlTrailPct = theArray[i].Sl[0].Trail
                if (theArray[i].Sl[0].Tptrail) {
                  theArray[i].Sltp.Status = 'TPT'
                }
              }

              if (theArray[i].Tps && theArray[i].Tps.length > 0) {
                if (!theArray[i].Sltp) {
                  theArray[i].Sltp = {}
                }

                let curstep = 0
                const steps = []

                theArray[i].Tps.forEach(step => {
                  if (step.Status === 'EXC') {
                    curstep++
                  }
                  steps.push(step)
                })

                // set cur tp step price, for compatibility with old version
                if (theArray[i].Tps.length > curstep) {
                  theArray[i].Sltp.TpPrice = theArray[i].Tps[curstep].Price
                }

                if (theArray[i].Tps[theArray[i].Tps.length - 1].Trail !== '0') {
                  theArray[i].Sltp.TpTrailPct = theArray[i].Tps[theArray[i].Tps.length - 1].Trail
                }
                theArray[i].Sltp.Steps = {
                  CurStep: curstep,
                  Steps: steps
                }
              }
            })

            // var c = performance.now()
            // console.log('process trades: ' + (c - b) + ' ms.')

            // ref.symbolsback.forEach(function (part, i, theArray) {
            //   // if (symbol.baseAsset === 'ADA'){
            //     // symbol.fav = true
            //   // }
            //   theArray[i].fav = false
            // })
            // console.log(response.data)
            store.state.trades.data = response.data // .reverse()
            store.state.trades.loading = false
          } else {
            store.state.trades.data = {
              Trades: [],
              Total: 0,
              Green: 0,
              Red: 0
            }
            store.state.trades.loading = false
          }
          // console.log(ref.symbols)
          // console.log(ref.trades)
        }).catch(function (error) {
          console.log(error)
        })
    }
  }
})
